import { combineReducers } from 'redux'
import EducatorInfoReducer from './reducers/educator-info.reducer'

const EducatorReducers = combineReducers({
    educatorInfo: EducatorInfoReducer,
})

export default EducatorReducers
export type RootState = ReturnType<typeof EducatorReducers>
